import { SearchSelectField } from '@/components/ui/SearchSelectField/SearchSelectField';
import { api } from '@/api/client';
import './SoundEngineerCombo.css';

const PAGE_SIZE = 50;
const MIN_SEARCH_LENGTH = 2;

export type SoundEngineerValueItem = { id: string; name: string; color?: string | null };

interface SoundEngineerComboProps {
  value: SoundEngineerValueItem | null;
  onChange: (value: SoundEngineerValueItem | null) => void;
  placeholder?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

export function SoundEngineerCombo({
  value,
  onChange,
  placeholder = 'Звукорежиссёр',
  disabled,
  fullWidth,
}: SoundEngineerComboProps) {
  return (
    <div className={fullWidth ? 'soundengineer-combo soundengineer-combo_full-width' : 'soundengineer-combo'}>
      <SearchSelectField<SoundEngineerValueItem>
        value={value}
        onChange={onChange}
        getOptionLabel={(e) => e.name}
        placeholder={placeholder}
        disabled={disabled}
        queryKey={['soundengineers', 'search-field']}
        minSearchLength={MIN_SEARCH_LENGTH}
        fetchPage={async (debouncedQuery, page) => {
          const res = await api.soundengineers.list(debouncedQuery, {
            limit: PAGE_SIZE,
            offset: page * PAGE_SIZE,
          });
          const items = res.items
            .filter((e) => !e.dismissed)
            .map((e) => ({ id: e.id, name: e.name, color: e.color }));
          return { items, hasMore: res.hasMore };
        }}
      />
    </div>
  );
}
